import { a11yProps, sizeTab } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import TableClientesBras from "../../shared/table_cliente_bras/TableClientesBras";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

export default function ClientesBrasPage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title={"Clientes BRAS"}
      visibleReport={true}
      enableRedirect={true}
      enableAccionBtn
      labelTextActionBtn={"Consumo"}
      iconActionBtn={<CloudDownloadIcon/>}
      fnAccionBtn={()=>alert("posible modal para selección de parámetros de consumo")}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'TODOS'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableClientesBras />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )

}